import { css } from "@emotion/react";
import styled from "@emotion/styled";
import colors from "../../styles/colors";
export const ButtonV2 = styled.button `
  border: 0;
  font-style: normal;
  font-weight: 600;
  font-family: Inter;
  cursor: pointer;
  ${(props) => getBackgroundColor(props.variant)}
  ${(props) => getBorderRadius(props.rounded, props.variant)}
  ${(props) => getPaddingAndFont(props.variant)}
`;
// identify padding, fontsize, lineHeight
function getBackgroundColor(variant) {
    switch (variant.type) {
        case "primary":
            return css `
        color: ${colors["color-white-100"]};
        background-color: ${colors["color-blue-120"]};

        &:disabled {
          background-color: ${colors["color-gray-40"]};
          color: ${colors["color-gray-110"]};
        }
        &:hover:enabled {
          background-color: ${colors["color-blue-90"]};
        }
        &:active:enabled {
          background-color: ${colors["color-blue-160"]};
        }
        &:focus-visible {
          background-color: ${colors["color-blue-160"]};
          border: 0.188rem solid ${colors["color-white-100"]};
          box-shadow: 0px 0px 0px 3px ${colors["color-blue-70"]};
          margin: -0.188rem;
        }
      `;
        case "secondary":
            return css `
        color: ${colors["color-blue-120"]};
        background-color: ${colors["color-white-100"]};
        border: 0.094rem solid;
        border-color: ${colors["color-blue-120"]};

        &:disabled {
          background-color: ${colors["color-gray-40"]};
          color: ${colors["color-gray-110"]};
          border-color: ${colors["color-gray-40"]};
        }
        &:hover:enabled {
          background-color: ${colors["color-blue-30"]};
        }
        &:active:enabled {
          background-color: ${colors["color-blue-160-20p"]};
          border-color: ${colors["color-blue-160"]};
          color: ${colors["color-blue-160"]};
        }
        &:active:enabled svg {
          fill: ${colors["color-blue-160"]};
        }
        &:focus-visible {
          background-color: ${colors["color-blue-30"]};
          color: ${colors["color-blue-160"]};
          border: 0.094rem solid ${colors["color-blue-160"]};
          box-shadow: 0px 0px 0px 3px ${colors["color-blue-70"]};
        }
        &:focus-visible svg {
          fill: ${colors["color-blue-160"]};
        }
      `;
        case "ghost":
            return css `
        color: ${colors["color-blue-120"]};
        background-color: ${variant.typography === "paragraph16" ||
                variant.typography === "paragraph14"
                ? colors["color-gray-20"]
                : colors["color-gray-30"]};

        &:disabled {
          background-color: ${colors["color-gray-40"]};
          color: ${colors["color-gray-110"]};
        }
        &:hover:enabled {
          background-color: ${variant.typography === "paragraph16" ||
                variant.typography === "paragraph14"
                ? colors["color-gray-30"]
                : colors["color-blue-30"]};
          color: ${variant.typography === "paragraph16" ||
                variant.typography === "paragraph14"
                ? colors["color-blue-110"]
                : colors["color-blue-100"]};
        }
        &:hover:enabled svg {
          fill: ${variant.typography === "paragraph16" ||
                variant.typography === "paragraph14"
                ? colors["color-blue-110"]
                : colors["color-blue-100"]};
        }
        &:active:enabled {
          background-color: ${colors["color-gray-40"]};
          color: ${colors["color-blue-160"]};
        }
        &:active:enabled svg {
          fill: ${colors["color-blue-160"]};
        }
        &:focus-visible {
          background-color: ${colors["color-blue-30"]};
          color: ${colors["color-blue-160"]};
          border: 0.094rem solid ${colors["color-blue-160"]};
          box-shadow: 0px 0px 0px 0.188rem ${colors["color-blue-70"]};
          margin-top: -0.094rem;
          margin-bottom: -0.094rem;
          margin-right: -0.047rem;
          margin-left: -0.047rem;
        }
        &:focus-visible svg {
          fill: ${colors["color-blue-160"]};
        }
      `;
        case "text":
            return css `
        color: ${colors["color-blue-120"]};
        background-color: transparent;
        svg {
          fill: ${colors["color-blue-120"]};
        }

        &:disabled {
          color: ${colors["color-gray-100"]};
        }
        &:disabled svg {
          fill: ${colors["color-gray-100"]};
        }
        &:hover {
          color: ${colors["color-blue-100"]};
        }
        &:hover:enabled svg {
          fill: ${colors["color-blue-100"]};
        }
        &:active:enabled {
          color: ${colors["color-blue-160"]};
        }
        &:active:enabled svg {
          fill: ${colors["color-blue-160"]};
        }
        &:focus-visible {
          color: ${colors["color-blue-160"]};
        }
        &:focus-visible svg {
          fill: ${colors["color-blue-160"]};
        }
      `;
    }
}
function getPaddingAndFont(variant) {
    switch (variant.typography) {
        case "paragraph12":
            switch (variant.type) {
                case "text":
                    return css `
            font-size: 0.75rem;
            line-height: 1.125rem;
          `;
                default:
                    return css `
            padding: 0.5rem 1rem;
            font-size: 0.75rem;
            line-height: 1.125rem;
          `;
            }
        case "paragraph14": {
            switch (variant.type) {
                case "text":
                    return css `
            font-size: 0.875rem;
            line-height: 1.25rem;
          `;
                default:
                    return css `
            padding: 0.75rem 1.5rem;
            font-size: 0.875rem;
            line-height: 1.25rem;
          `;
            }
        }
        case "paragraph16":
            switch (variant.type) {
                case "text":
                    return css `
            font-size: 1rem;
            line-height: 1.5rem;
          `;
                default:
                    return css `
            padding: 0.75rem 1.5rem;
            font-size: 1rem;
            line-height: 1.5rem;
          `;
            }
        case "paragraph10":
            return css `
        font-size: 10px;
        font-weight: 600;
        line-height: 16px;
      `;
        case "paragraph9":
            return css `
        padding: 0.375rem 0.75rem;
        font-size: 0.563rem;
        line-height: 1rem;
      `;
    }
}
function getBorderRadius(rounded, variant) {
    switch (rounded) {
        case true:
            return css `
        border-radius: 9999px;
      `;
        default:
            switch (variant.typography) {
                case "paragraph14":
                    return css `
            border-radius: 0.5rem;
          `;
                default:
                    return css `
            border-radius: 0.25rem;
          `;
            }
    }
}
export const ButtonV2Content = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) => getSidePadding(props.variant, props.iconLeft, props.iconRight)}
  ${(props) => getGap(props.variant, props.iconLeft, props.iconRight)}
`;
function getSidePadding(variant, iconLeft, iconRight) {
    switch (variant.type) {
        case "text":
            return;
        default:
            switch (variant.typography) {
                case "paragraph14":
                    if (iconLeft)
                        return css `
              padding-right: 0.5rem;
            `;
                    if (iconRight)
                        return css `
              padding-left: 0.5rem;
            `;
                    return;
                default:
                    if (iconLeft)
                        return css `
              padding-right: 0.25rem;
            `;
                    if (iconRight)
                        return css `
              padding-left: 0.25rem;
            `;
                    return;
            }
    }
}
function getGap(variant, iconLeft, iconRight) {
    switch (variant.type) {
        case "text":
            switch (variant.typography) {
                case "paragraph16":
                    if (iconLeft || iconRight)
                        return css `
              gap: 0.25rem;
            `;
                    return;
                default:
                    if (iconLeft || iconRight)
                        return css `
              gap: 0.125rem;
            `;
                    return;
            }
        default:
            switch (variant.typography) {
                case "paragraph14":
                    if (iconLeft || iconRight)
                        return css `
              gap: 0.25rem;
            `;
                    return;
                default:
                    if (iconLeft || iconRight)
                        return css `
              gap: 0.125rem;
            `;
                    return;
            }
    }
}
//# sourceMappingURL=ButtonV2.styled.js.map